export const ROLES = Object.freeze({
  OPERARIO: "Operario",
  DIRECTOR: "Director",
  CONTABILIDADE: "Contabilidade",
  RECARGA_TEST: "recargatest",
  COMERCIAL: "Comercial",
  TECNICO: "Tecnico",
  IRS: "IRS",
});

// O comercial e o técnico não têm entrada aqui de propósito: trabalham na app
// móvel e não há painel web para nenhum dos dois. Enquanto apontavam para
// "/home", entravam e recebiam a consola do operário.
//
// O servidor recusa-lhes o login (ver `pode_entrar_na_consola_web`); isto é a
// segunda tranca, não a primeira.
export const ROLE_HOME = Object.freeze({
  [ROLES.DIRECTOR]: "/admin/home",
  [ROLES.OPERARIO]: "/home",
  [ROLES.CONTABILIDADE]: "/cont/home",
  [ROLES.RECARGA_TEST]: "/test/home",
  [ROLES.IRS]: "/irs/home",
});

export const ROLE_PRIORITY = [
  ROLES.DIRECTOR,
  ROLES.OPERARIO,
  ROLES.COMERCIAL,
  ROLES.IRS,
  ROLES.TECNICO,
  ROLES.CONTABILIDADE,
  ROLES.RECARGA_TEST,
];

export function normalizeRoles(value) {
  if (Array.isArray(value)) return value.filter(Boolean);
  if (!value) return [];
  return [value];
}

export function primaryRole(roles = [], fallback = ROLES.OPERARIO) {
  const normalized = normalizeRoles(roles);
  return ROLE_PRIORITY.find((role) => normalized.includes(role)) || normalized[0] || fallback;
}

export function routeForRoles(roles = [], fallbackRole) {
  return ROLE_HOME[primaryRole(roles, fallbackRole)] || ROLE_HOME[ROLES.OPERARIO];
}
